export default {"src":"__ASTRO_ASSET_IMAGE__B79JE5Cj__","width":564,"height":797,"format":"png"}